import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CreditCard from '~/Common-Objects/UI/Payment/card'
import DrawerConfirm from '~/Common-Objects/UI/Drawer/DrawerConfirm'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import { connect } from 'react-redux'
import axios from '~/data/http/axios'
import AddCard from './addCardStripe'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import SiteVars from '~/Classes/siteVars'

@connect((store) => {
    return { user: store.user, account: store.accountMaster, siteMaster: store.siteMaster }
})
class StripeElement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            addCard: false,
            customer: undefined,
            cards: [],
            deleteDrawer: '',
            alertMessage: '',
            alertOpen: false,
            loading: true,
            stripeLoaded: false,
            approveDrawer: null
        }

        this.stripe = null
        this.getCustomer = this.getCustomer.bind(this)
        this.makeDefault = this.makeDefault.bind(this)
        this.addCard = this.addCard.bind(this)
        this.deleteCard = this.deleteCard.bind(this)
        this.deleteCardGo = this.deleteCardGo.bind(this)
    }

    componentDidMount() {
        this.getCustomer()
        const self = this

        async function checkStripe() {
            if (!self.stripe) {
                console.log('getting stripe')
                if (window.Stripe) {
                    self.stripe = Stripe(SiteVars.stripeKey)
                    self.setState({ stripeLoaded: true })
                } else {
                    await new Promise((resolve, reject) => {
                        setTimeout(resolve, 300)
                    })
                    checkStripe()
                }
            }
        }
        checkStripe()
    }

    getCustomer() {
        axios
            .get('/accountMaster/paymentMethod/stripe')
            .then((response) => {
                this.setState({
                    customer: response.data.customer,
                    cards: response.data.customer.sources.data || [],
                    loading: false
                })
            })
            .catch(console.log)
    }

    addCard() {
        var drawerContent = (
            <AddCard
                stripe={this.stripe}
                close={() => {
                    this.getCustomer()
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '100vw', 'full'))
    }

    makeDefault(cardId) {
        this.setState({
            alertMessage: 'Setting Default',
            alertOpen: true
        })
        axios
            .put('/accountMaster/paymentMethod/stripe', {
                default_source: cardId
            })
            .then(() => {
                var customer = this.state.customer
                customer.default_source = cardId
                this.setState({
                    customer: customer,
                    alertMessage: 'Default Set',
                    alertOpen: true
                })
            })
            .catch((err) => {
                this.setState({
                    alertMessage: 'Error Settings Default',
                    alertOpen: true
                })
                console.log(err)
            })
    }

    deleteCard(cardId) {
        var drawerContent = (
            <DrawerConfirm
                header={'Delete Card?'}
                showCancel={true}
                cancel={() =>
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true, null, 'full'))
                }
                confirm={() => {
                    this.deleteCardGo(cardId)
                }}
            />
        )

        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true))
    }

    deleteCardGo(cardId) {
        let self = this
        self.setState({
            alertMessage: 'Deleting Card',
            alertOpen: true
        })
        axios
            .delete('/accountMaster/paymentMethod/stripe/' + cardId)
            .then(() => {
                self.setState({
                    alertMessage: 'Card Deleted',
                    alertOpen: true,
                    deleteDrawer: ''
                })
                self.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true))
                self.getCustomer()
            })
            .catch((err) => {
                self.setState({
                    alertMessage: 'Error Deleting Card',
                    alertOpen: true
                })
                console.log(err)
            })
    }

    requestApproval() {
        this.props.dispatch(
            siteMaster.alterFullpage(
                <NewUserForm
                    from='payment'
                    finish={() => {
                        this.props.dispatch(siteMaster.alterFullpage(undefined))
                    }}
                />
            )
        )
    }

    render() {
        // if (this.props.account.accountMaster.accountType === 'free' && !this.state.cards.length) return <div></div>
        if (!this.state.stripeLoaded) return <LoadingIcons iconType='2' />
        if (this.state.loading) return <LoadingIcons iconType='2' />

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
                    {this.state.cards.map((card, index) => {
                        return (
                            <div key={index}>
                                <CreditCard
                                    default={this.state.customer.default_source}
                                    card={card}
                                    makeDefault={this.makeDefault}
                                    deleteCard={this.deleteCard}
                                    allowDelete={this.state.cards?.length > 1}
                                    readOnly={!this.props.writeAccess}
                                />
                            </div>
                        )
                    })}
                </div>

                {this.props.writeAccess && (
                    <div>
                        <Button
                            text='Add Payment Method'
                            className='button-sml'
                            onClick={this.addCard}
                            iconLeft={<Icons icon='plus' />}
                        />
                    </div>
                )}
                <SnackBar
                    message={this.state.alertMessage}
                    open={this.state.alertOpen}
                    autoclose={true}
                    dismiss={() => this.setState({ alertOpen: false })}
                />
                {this.state.deleteDrawer}

                {this.state.approveDrawer}
            </div>
        )
    }
}

export default StripeElement
